import React from 'react';

import { Svg, useSvgColor } from '~/assets/icons/styles';

const PlayWithLinesIcon = ({ color, ...props }) => {
  const svgColor = useSvgColor(color);

  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      svgColor={svgColor}
      {...props}
    >
      <path
        d="M12.9925 18.8198C12.7877 18.9417 12.5572 19.0038 12.3236 18.9998C12.09 18.9959 11.8613 18.9261 11.6602 18.7974C11.4591 18.6686 11.2924 18.4854 11.1766 18.2656C11.0609 18.0459 11 17.7973 11 17.5443V6.45572C10.9999 6.20272 11.0607 5.95407 11.1765 5.7343C11.2922 5.51452 11.4589 5.33122 11.6601 5.20248C11.8612 5.07374 12.0899 5.00401 12.3236 5.00017C12.5572 4.99633 12.7878 5.05851 12.9925 5.18058C15.4864 6.66533 19.7412 9.1996 22.3034 10.7251C22.5143 10.8506 22.6903 11.0352 22.8128 11.2595C22.9354 11.4838 23 11.7396 23 12.0002C23 12.2609 22.9354 12.5167 22.8128 12.741C22.6903 12.9653 22.5143 13.1499 22.3034 13.2754C19.7412 14.8009 15.4864 17.3347 12.9925 18.8198Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7 7H4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M7 12L2 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M7 17L1 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </Svg>
  );
};

export default PlayWithLinesIcon;
